import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  0% { opacity: 0;}
  100% { opacity: 100;}
`

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  background: rgba(17, 36, 38, 0.8);
  animation: ${fadeIn} .3s ease forwards;
  z-index: 10;
  &.open {
    opacity: 1;
    display: block;
    transition: all .5s ease;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.closed {
    display: none;
    opacity: 0;
    pointer-events: none; 
    touch-action: none;
    transition: all .5s ease-out;
  }
`

export const ImageContainer = styled.div`
  width: auto;
  height: auto;
  max-height: 570px;
  max-width: 80%;
  opacity: 0;
  animation: ${fadeIn} .3s ease forwards .2;
  @media (min-width: 768px) {
    max-height: 570px;
    max-width: 1050px;
  }
`

export const CloseContainer = styled.div`
  position: absolute;
  top: 20px; 
  left: 20px;
  @media (min-width: 768px) {
    left: initial;
    right: 30px;
  }
`

export const Image = styled.img`
  max-height: 420px;
  object-fit: contain;
  max-width: 100%;

  @media (max-width: 767px) {
    max-width: 100%;
  }
`
export const ButtonHide = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom: solid 1px #AEDBD9;

  @media (min-width: 768px) {
    bottom: 100px;
    left: 100px;
    transform: translateX(0);
  }

  @media (min-width: 768px) and (max-height: 700px){
    bottom: 30px;
  }
`;

export const Description = styled.p`
  font-family: 'Amorim Sans Book';
  text-transform: uppercase;
  width: 100%;
  font-size: 16px;
  letter-spacing: 1.9px;
  color: #AEDBD9;
  margin-bottom: 0;
  white-space: nowrap;
  cursor: pointer;
`
